/**
 * Partial.ly
 *
 * Inline script instantiates Partial.ly.
 */
document.querySelector('#js-partially img').outerHTML =
  '<div class="btn btn__right-arrow partially--btn">Pay in Installments</div>';

/**
 * Note to Seller:
 *   - toggle textarea visibility
 *   - save note
 *   - show save progress
 */
(function() {
  const button = document.getElementById('js-cart-note--toggle');
  const input = document.getElementById('CartSpecialInstructions');

  (function saveInput() {
    const hideProgress = (() => {
      const all = document.querySelectorAll('.js-cart-note--flash');
      return () => all.forEach(el => el.hidden = true);
    })();

    const showProgress = (() => {
      const saving = document.getElementById('js-cart-note--flash__saving');
      const saved = document.getElementById('js-cart-note--flash__saved');
      const error = document.getElementById('js-cart-note--flash__error');

      return (state) => {
        hideProgress();
        switch(state) {
          case 'saving': saving.hidden = false; break;
          case 'saved': saved.hidden = false; break;
          case 'error': error.hidden = false; break;
        }
      }
    })();

    const handleInput = window.APP.debounce(evt => {
      showProgress('saving');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ note: evt.target.value }),
      })
      .then(res => {
        if (!res.ok) {
          showProgress('error');
          throw `HTTP response status code: ${res.status}`;
        } else {
          if (evt.target.value.trim()) showProgress('saved');
          else hideProgress();
        }
      })
      .catch(err => {
        showProgress('error');
        window.APP.gaError('Update cart note', err);
      });
    }, 450);

    input.addEventListener('input', handleInput);
  })();


  (function manageVisibility() {
    // Use `mousedown` event to resolve race condition between `click` and `blur`
    button.addEventListener('mousedown', function() {
      if (input.hidden) input.hidden = false;
    });

    input.addEventListener('blur', function() {
      if (this.value.trim() === '') this.hidden = true;
    });
  })();
})();

/**
 * Interactively update line item quantities and cart prices
 */
(function() {
  const qtyInputs = document.querySelectorAll('.js-quantity-input');
  const subtotal = document.getElementById('js-subtotal');
  const shippingFree = document.getElementById('js-shipping-free');
  const shippingPrice = document.getElementById('js-shipping-price');
  const grandTotalLocal = document.getElementById('js-total-local');
  const grandTotalEuro = document.getElementById('js-total-euro');
  const discountsRow = document.getElementById('discounts-row');
  const discountsList = document.getElementById('js-discounts-list');
  const totalSaleAmountEl = document.getElementById('js-total-sale-amount');

  /**
   * It is unnecessary to update the `data-price` attributes as its only
   * purpose is to allow `window.APP.convertPrice` to convert currencies at
   * document load.
   */
  function updateCart() {
    /**
      * A map of variant ID to quantity.
      * @typedef {Object.<string, number>}
      * @example
      * {
      *   "123": 1, // Variant ID "123" with quantity 1
      *   "456": 2, // Variant ID "456" with quantity 2
      * }
      */
    const cartData =
      Object.fromEntries(
        Array.from(qtyInputs)
          .map(el => {
            const variantID = el.dataset.variantId;
            const qty = parseInt(el.value);
            return [variantID, qty];
          })
      );

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: cartData }),
    })
    .then(res => {
      if (!res.ok) throw `HTTP response status code: ${res.status}`;
      return res.json()
    })
    .then(cart => {
      // The cart object does not expose total compare-at-prices. It must be
      // manually summed.
      let totalSaleAmount = 0;

      // Cart Count (global header and drawer)
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.dataset.count = el.textContent = cart.item_count;
      });

      // Cart Item Prices
      cart.items.forEach(item => {
        const row = document.getElementById(`js-line-item-${item.variant_id}`);
        const nonSalePrice = row.querySelector('.js-cart-items--non-sale-price');
        const price = row.querySelector('.js-cart-items--price');

        price.dataset.price = item.discounted_price;
        price.innerHTML = window.APP.convertPrice.convert(item.discounted_price);

        const isSlashed = nonSalePrice.dataset.price > item.discounted_price;
        if (isSlashed) {
          nonSalePrice.classList.remove('hidden');
          price.classList.add('cart-items--reduced-price');
          totalSaleAmount += (nonSalePrice.dataset.price * item.quantity) - item.final_line_price;
        } else {
          nonSalePrice.classList.add('hidden');
          price.classList.remove('cart-items--reduced-price');
        }

        const linePrice = row.querySelector('.js-cart-items--line-price');
        linePrice.dataset.price = item.line_price;
        linePrice.innerHTML = window.APP.convertPrice.convert(item.line_price);
      });

      // Subtotal
      subtotal.innerHTML = window.APP.convertPrice.convert(cart.total_price);

      // Shipping Price
      let shippingPriceValue;
      if (cart.total_price >= window.APP.templateSpecific.thresholdFree) {
        shippingFree.hidden = false;
        shippingPrice.hidden = true;
        shippingPriceValue = 0;
      } else {
        shippingFree.hidden = true;
        shippingPrice.hidden = false;
        shippingPriceValue = window.APP.templateSpecific.shippingPriceFull;
        shippingPrice.innerHTML = window.APP.convertPrice.convert(shippingPriceValue);
      }

      // Grand Total (Local Currency and Euro)
      const grandTotalEuroValue = cart.total_price + shippingPriceValue;
      grandTotalLocal.innerHTML = window.APP.convertPrice.convert(grandTotalEuroValue);
      grandTotalEuro.textContent = '€' + Math.ceil(grandTotalEuroValue / 100).toLocaleString('en-US');

      // Discounts
      totalSaleAmountEl.hidden = totalSaleAmount === 0;
      totalSaleAmountEl.innerHTML = window.APP.convertPrice.convert(totalSaleAmount);

      document.querySelectorAll('.js-discount-application').forEach(row => row.remove());
      if (cart.cart_level_discount_applications.length) {
        let html = '';
        cart.cart_level_discount_applications.forEach(({ discount_application }) => {
          html += /* html */`
            <li class="js-discount-application">
              <span class="cart-summary--discount-amount js-money" data-price="${ discount_application.total_allocated_amount }">${window.APP.convertPrice.convert(discount_application.total_allocated_amount)}</span>
              (${ discount_application.title })
            </li>
          `;
        })
        discountsList.insertAdjacentHTML('beforeend', html);
      }

      discountsRow.hidden = totalSaleAmountEl.hidden && !cart.cart_level_discount_applications.length;
    })
    .catch(err => window.APP.gaError('Update cart quantity', err));
  }

  qtyInputs.forEach(el => el.addEventListener('input', updateCart));
})();

/**
 * Wishlist
 */
// Wait for window.APP and wishlist data to be ready.
document.addEventListener('DOMContentLoaded', function() {
  const list = document.querySelector('#js-cart-items--list');

  // Cart is empty.
  if (!list) {
    return;
  }

  // Wishlist is disabled in theme settings.
  if (list.querySelectorAll('.js-add-to-wishlist').length === 0) {
    return;
  }

  if (!window.APP.wishlist?.isEnabled) {
    list.querySelectorAll('.js-add-to-wishlist').forEach(button => {
      button.hidden = false;
      button.addEventListener('click', async function() {
        window.APP.loginPopup.open({ showNotice: 'add' });
      });
    });
    return;
  }

  updateButtons();
  window.APP.wishlist.registerUpdateListener(updateButtons);

  function updateButtons() {
    const productIds = window.APP.wishlist.data.map(item => item.productId);
    list.querySelectorAll('.js-add-to-wishlist').forEach(button => {
      if (!productIds.includes(Number(button.dataset.productId))) {
        button.hidden = false;
        button.addEventListener('click', async function() {
          button.disabled = true;
          const response = await window.APP.wishlist.add(button.dataset.productId);
          if (response) {
            button.hidden = true;
            button.parentElement.querySelector('.js-add-to-wishlist--success').hidden = false;
          }
          button.disabled = false;
        });
      }
    });
  }
});
